import { NgModule } from "@angular/core";
import { environment } from "../environments/environment";
import { SelectivePreloadingStrategy } from "./core/selective-preloading-strategy";
import { RouterModule, Routes } from "@angular/router";
import { ViewEventComponent } from "./home/component/view-event/view-event.component";
import { PublicGalleryComponent } from "./shared/components/public-gallery/public-gallery.component";
import { CallbackComponent } from './callback/callback.component';
import { AuthGuard } from "./core/interceptor/authGuard";
import { GuestRestrictionGuard } from "./core/interceptor/guest-restriction.guard";
import { SplashScreenComponent } from "./shared/components/splash-screen/splash-screen.component";
import { CreateEventComponent } from "./create-event/create-event.component";
import { QrInviteComponent } from "./create-event/qr-invite/qr-invite.component";
import { SelfieLandingPageComponent } from "./selfie-landing-page/selfie-landing-page.component";
import { EventSettingsComponent } from "./event-settings/event-settings.component";
import { EventSettingsV2Component } from "./event-settings-v2/event-settings-v2.component";
import { CoverImageComponent } from "./cover-image/cover-image.component";
import { AdminMenuComponent } from "./admin-menu/admin-menu.component";
import { PhotowallEventlistComponent } from "./photo-wall/photowall-eventlist/photowall-eventlist.component";
import { PhotowallConfigurationComponent } from "./photo-wall/photowall-configuration/photowall-configuration.component";
import { EditPastEventComponent } from "./edit-past-event/edit-past-event.component";
import { EventBrandingComponent } from "./event-branding/event-branding.component";
import { QrRedirectComponent } from "./qr-redirect/qr-redirect.component";
import { SelfieRedirectComponent } from "./selfie-redirect/selfie-redirect.component";
import { CreateEventsComponent } from "./create-events/create-events.component";
import { EventConfigurationsComponent } from "./event-configurations/event-configurations.component";
import { MyPhotosConfigurationComponent } from "./my-photos-configuration/my-photos-configuration.component";
import { InviteDialogComponent } from "./invite-dialog/invite-dialog.component";
import { EventResolver } from "./core/route-resolver";
import { PaymentTestComponent } from "./payment-test/payment-test.component";
import { AddBrandingComponent } from "./add-branding/add-branding.component";
import { UpdateEventComponent } from "./update-event/update-event.component";
import { DemoLandingComponent } from './demo-landing/demo-landing.component';
import { DemoDirectGalleryComponent } from './demo-direct-gallery/demo-direct-gallery.component';
import { MyEventsComponent } from './myevents/myevents.component';
import { AlbumSwitchComponent } from './album-switch/album-switch.component';
const routes: Routes = [
  { path: "demo-landing", component: DemoLandingComponent },
  { path: "demo-event", redirectTo: 'demo-direct-gallery', pathMatch: 'full' },
  { path: "demo-direct-gallery", component: DemoDirectGalleryComponent },
  { path: "create-demo-event", redirectTo: 'demo-direct-gallery', pathMatch: 'full' },
  { path: "qr-redirect/:id", component: QrRedirectComponent },// redirectTo: 'splash/:id', pathMatch: 'full' },
  { path: "splash/:id", component: SplashScreenComponent },
  { path: "event-invite/:id", loadChildren: () => import('./event-invite/event-invite.module').then(m => m.EventInviteModule) },
  { path: "rsvp-response", loadChildren: () => import('./rsvp/rsvp.module').then(m => m.RsvpModule) },
  { path: "open-rsvp-response", loadChildren: () => import('./open-rsvp-response/open-rsvp-response.module').then(m => m.OpenRsvpResponseModule) },

  { path: "gallery/:id", loadChildren: () => import('./gallery/gallery.module').then(m => m.GalleryModule) },
  { path: "view-gallery/:id", loadChildren: () => import('./view-gallery/view-gallery.module').then(m => m.ViewGalleryModule) },
  { path: 'photowall', loadChildren: () => import('./photo-wall/photowall-configuration/photowall.module').then(m => m.PhotowallModule) },
  // Public shared flipbook. No guard on purpose: whoever opens this was sent a
  // link and probably has no account, so anything that asks them to sign in
  // defeats the point. Sits with the other unguarded routes above.
  //
  // Registered only when the feature is on. The flag already hides the button
  // that creates a flipbook, but the route is the one flipbook surface that
  // does not go through that button — a link created on the test deploy would
  // otherwise still render on production. Off means off, including here.
  ...(environment.features.flipbook
    ? [{ path: "flipbook/:shareId", loadChildren: () => import('./flipbook-share/flipbook-share.module').then(m => m.FlipbookShareModule) }]
    : []),
  {
    path: "auth",
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "home",
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    runGuardsAndResolvers: 'always',
    data: { animation: 'HomePage', preload: true },
    canActivate: [GuestRestrictionGuard]
    // resolve: { eventData: EventResolver }

    //, canActivate: [AuthGuard]
  },
  {
    path: "myevents", component: MyEventsComponent,
    runGuardsAndResolvers: 'always',
    data: { animation: 'MyEventsPage' },
    canActivate: [GuestRestrictionGuard]
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: "my-photos/:id",
    loadChildren: () => import('./myphotos-home/myphotos-home.module').then(m => m.MyphotosHomeModule),
    canActivate: [GuestRestrictionGuard]
    // resolve: { eventData: EventResolver }

    //, canActivate: [AuthGuard] 
  },
  {
    path: "event-info", component: UpdateEventComponent,
    canActivate: [GuestRestrictionGuard]
    //EventConfigurationsComponent
    //, canActivate: [AuthGuard] 
  },
  {
    path: "open-event-detail/:id",
    loadChildren: () => import('./open-event-detail/open-event-detail.module').then(m => m.OpenEventDetailModule),
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard]
  },
  {
    path: "open-invite/:id",
    loadChildren: () => import('./open-event-invite/open-event-invite.module').then(m => m.OpenEventInviteModule),
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard]
  }, {
    path: "more-info", component: PaymentTestComponent
    // , canActivate: [AuthGuard] 
  },

  {
    path: "branding-settings",
    loadChildren: () => import('./branding-settings/branding-settings.module').then(m => m.BrandingSettingsModule),
    canActivate: [GuestRestrictionGuard]
    // , canActivate: [AuthGuard]
  },
  {
    path: "manage-event",
    loadChildren: () => import('./manage-event/manage-event.module').then(m => m.ManageEventModule),
    canActivate: [GuestRestrictionGuard]
  },
  {
    path: '',
    loadChildren: () => import('./subscription/subscription.module').then(m => m.SubscriptionModule),
    canActivate: [GuestRestrictionGuard]
  },
  {
    path: "my-account",
    loadChildren: () => import('./my-account/my-account.module').then(m => m.MyAccountModule),
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard]
  },
  {
    path: "edit-event-info",
    loadChildren: () => import('./edit-event-configuration/edit-event-configuration.module').then(m => m.EditEventConfigurationModule),
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard]
  },
  {
    path: "my-photos-config", component: MyPhotosConfigurationComponent,
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard] 
  },
  {
    path: "edit-event",
    loadChildren: () => import('./edit-event/edit-event.module').then(m => m.EditEventModule),
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard]
  },
  {
    path: "event-branding", component: EventBrandingComponent,
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard] 
  },
  {
    path: "admin-menu", component: AdminMenuComponent,
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard] 
  },
  {
    path: "feature-settings",
    loadChildren: () => import('./feature-settings/feature-settings.module').then(m => m.FeatureSettingsModule),
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard]
  },
  {
    path: "host",
    loadChildren: () => import('./host-transfer/host-transfer.module').then(m => m.HostTransferModule),
    canActivate: [GuestRestrictionGuard]
  },
  {
    path: "host-transfer",
    loadChildren: () => import('./host-transfer/host-transfer.module').then(m => m.HostTransferModule),
    canActivate: [GuestRestrictionGuard]
  },
  {
    path: "pricing",
    loadChildren: () => import('./pricing/pricing.module').then(m => m.PricingModule),
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard]
  },
  {
    path: "invitation",
    loadChildren: () => import('./invitation/invitation.module').then(m => m.InvitationModule),
    canActivate: [GuestRestrictionGuard]
  },
  {
    path: "autopilot",
    loadChildren: () => import('./autopilot/autopilot.module').then(m => m.AutopilotModule),
    canActivate: [GuestRestrictionGuard]
  },
  {
    path: "how-to-videos",
    loadChildren: () => import('./how-to-videos/how-to-videos.module').then(m => m.HowToVideosModule),
    canActivate: [GuestRestrictionGuard]
  },
  {
    path: "reels",
    loadChildren: () => import('./reels/reels.module').then(m => m.ReelsModule),
    canActivate: [GuestRestrictionGuard]
  },
  {
    path: "purchase-history",
    loadChildren: () => import('./transaction/transaction.module').then(m => m.TransactionModule),
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard]
  },
  { path: 'payment-status', loadChildren: () => import('./payment-status/payment-status.module').then(m => m.PaymentStatusModule) },
  {
    path: "select-photowall", component: PhotowallEventlistComponent,
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard] 
  },
  {
    path: "photowall-configuration", component: PhotowallConfigurationComponent,
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard] 
  },
  {
    path: "upcoming-event",
    loadChildren: () => import('./schedule-event/schedule-event.module').then(m => m.ScheduleEventModule),
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard] 
  },
  {
    path: "invite-guests", component: InviteDialogComponent,
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard] 
  },
  {
    path: "guest-invite",
    loadChildren: () => import('./guest-invite/guest-invite.module').then(m => m.GuestInviteModule),
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard]
  },
  // {
  //   path: "cover-image", component: CoverImageComponent
  //   //, canActivate: [AuthGuard] 
  // },
  {
    path: "preview-invite",
    loadChildren: () => import('./preview-invite/preview-invite.module').then(m => m.PreviewInviteModule),
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard] 
  },
  {
    path: "event-storage",
    loadChildren: () => import('./event-storage/event-storage.module').then(m => m.EventStorageModule),
    canActivate: [GuestRestrictionGuard]
  },
  {
    path: "admin",
    loadChildren: () => import('./admin-settings/admin-settings.module').then(m => m.AdminSettingsModule),
    canActivate: [GuestRestrictionGuard]
  },
  {
    path: "add-branding", component: AddBrandingComponent,
    canActivate: [GuestRestrictionGuard]
  },
  {
    path: "public-settings",
    loadChildren: () => import('./public-settings/public-settings.module').then(m => m.PublicSettingsModule),
    canActivate: [GuestRestrictionGuard]
  },
  // Legacy "Set Image Visibility" page, retired 2026-10-28: nothing but
  // admin-settings linked to it, and anyone signed in could type the URL and
  // open it for the last event on the device (collaborators included).
  // Manage Event is the one settings screen and already limits non-hosts.
  // {
  //   path: "event-settings", component: EventSettingsComponent,
  //   canActivate: [GuestRestrictionGuard]
  // },
  { path: "event-settings", redirectTo: "manage-event" },
  {
    path: "event-settings-v2", component: EventSettingsV2Component,
    canActivate: [GuestRestrictionGuard]
  },
  {
    path: "edit-past-event", component: EditPastEventComponent,
    canActivate: [GuestRestrictionGuard]
  },
  {
    path: "slideshow",
    loadChildren: () => import('./slideshow/slideshow.module').then(m => m.SlideshowModule)
    //, canActivate: [AuthGuard]
  },
  {
    path: "scan-qr",
    loadChildren: () => import('./scan-qr/scan-qr.module').then(m => m.ScanQrModule),
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard]
  },
  {
    path: "upload-selfie", component: SelfieLandingPageComponent,
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard] 
  },
  {
    path: "selfie-redirect/:id", component: SelfieRedirectComponent,
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard] 
  },
  {
    path: "selfie-message",
    loadChildren: () => import('./selfie-message/selfie-message.module').then(m => m.SelfieMessageModule),
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard]
  },
  // {
  //   path: "create-event2", component: CreateEventComponent
  //   //, canActivate: [AuthGuard] 
  // },
  {
    path: "create-event", component: CreateEventsComponent,
    canActivate: [GuestRestrictionGuard]
  },
  {
    path: "invite-users", component: QrInviteComponent,
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard] 
  },
  { path: "public/:id", component: PublicGalleryComponent },
  {
    path: "event-detail/:id",
    loadChildren: () => import('./event-detail/event-detail.module').then(m => m.EventDetailModule),
    runGuardsAndResolvers: 'always',
    data: { preload: true },
    // resolve: { eventData: EventResolver }
  },
  // Empty stop for switching the album page to another album without a reload
  // (see AlbumSwitchComponent). No guard on purpose: link guests use it too.
  { path: "album-switch", component: AlbumSwitchComponent },
  {
    path: "view-event", component: ViewEventComponent,
    canActivate: [GuestRestrictionGuard]
    //, canActivate: [AuthGuard] 
  },
  { path: "callback", component: CallbackComponent },
  //{ path: "payment-test", component: PaymentTestComponent },
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload', preloadingStrategy: SelectivePreloadingStrategy })],//[RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
